import React from 'react';
import { Button, Popover, Modal, ModalHeader, ModalFooter, ModalBody, Row, Col, FormGroup, Input, Label, Progress, Alert } from 'reactstrap';
import Editor from '../Editor';
import $ from 'jquery';
import { withAlert } from 'react-alert';
import TemplateExistsModal from './TemplateExistsModal';
import { connect } from 'react-redux';
import ValidateSelect from '../ValidateSelect';
import EmailSubject from '../EmailSubject';

class NewReportModal extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            selectedFolder: '',
            html: '',
            rawHtml: '',
            subject: '',
            isLoading: false,
            templateExistsModal: false,
            existingFile: {},
            showtext: true,
            value: false,
            templates: [],
            saveError: false,
            errorMessage: '',
            admin_email: '',
            useDefault: true,
            distributionReports: false,
            sendReportsOnCompletion: false,
            valid: false,
            userAlertMessage: '',
            userAlertType: '', // 'info' | 'error' | etc.
            showUserAlert: false,
            hasInteracted: false,
            ...props
        }
    }

    useDefaultCheckChange = (e) => {
        const target = e.target;
        const value = target.checked;
        this.setState({
            useDefault: value
        });
    }

    componentDidMount = () => {
        this.formIsLoading();
        this.getX3Folders()

        if (this.props.file)
            this.setState({
                templates: this.props.file.templates
            })
    }

    componentDidUpdate(prevProps, prevState) {
        const {
            selectedFolder,
            selectedLanguage,
            selectedCode,
            templates,
            valid
        } = this.state;
    
        // Optional: safety revalidation in case dropdowns were changed externally
        if (
            selectedFolder !== prevState.selectedFolder ||
            selectedLanguage !== prevState.selectedLanguage ||
            selectedCode !== prevState.selectedCode
        ) {
            const isValid =
                this.isDefaultDropdownValue(selectedFolder) &&
                this.isDefaultDropdownValue(selectedLanguage) &&
                this.isDefaultDropdownValue(selectedCode);
    
            if (valid !== isValid) {
                this.setState({ valid: isValid });
            }
        }
    }
    

    formIsLoading = () => {
        this.setState({
            isLoading: true
        });
    }

    checkTemplateExists = () => {
        fetch(window.location.protocol + '//' + window.location.host + '/api/email/get_email_template?template=' + this.state.selectedCode + '&folder=' + this.state.selectedFolder + '&language=' + this.state.selectedLanguage)
            .then(res => res.json())
            .then(result => {
                if (!result || result.length == 0)
                    this.saveTemplate();
                else
                    this.setState({
                        templateExistsModal: true,
                        existingFile: result
                    })
            })
    }

    newVersionOfTemplate = () => {
        fetch(window.location.protocol + '//' + window.location.host + "/api/email/create_new_version_of_template", {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                _id: this.state.existingFile.parentId ? this.state.existingFile.parentId : this.state.existingFile._id,
                templates: this.state.templates,
                use_default: this.state.useDefault
            })
        })
            .then(res => res.json())
            .then(result => {
                this.setState({
                    templateExistsModal: false
                })
                this.props.alert.success(result.message);
                this.props.toggle();
                this.props.refresh();
            })
    }

    saveTemplate = () => {
        this.setState({
            saveError: false,
            errorMessage: ''
        })

        if (!this.state.subject) {
            this.setState({
                saveError: true,
                errorMessage: 'Please enter a subject for the email tempalte'
            })
            return
        }
        else if (this.state.templates.length == 0) {
            this.setState({
                saveError: true,
                errorMessage: 'Please add some text to at least one email body'
            })
            return
        }
        else if (this.state.templates[0].html == '') {
            this.setState({
                saveError: true,
                errorMessage: 'Please add some text to at least one email body'
            })
            return
        }

        fetch(window.location.protocol + '//' + window.location.host + "/api/email/create_new_template", {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                template: this.state.selectedCode,
                selectTemplateIndex: this.state.selectTemplateIndex,
                folder: this.state.selectedFolder,
                language: this.state.selectedLanguage,
                subject: this.state.subject,
                admin_email: this.state.admin_email,
                templates: this.state.templates,
                use_default: this.state.useDefault,
                distribution_report: this.state.distributionReports,
                send_on_completion: this.state.sendReportsOnCompletion
            })
        })
            .then(res => {
                if (res.ok && res.status == 200)
                    return res.json()
                else if (res.status == 413)
                    throw Error("Template size too large, please remove or compress any large images and retry ...")
                else if (res.status == 404) {
                    this.props.alert.error("Unable to save, document type config for selected report does not exist.");
                    throw Error("Unable to save, document type config for selected report does not exist.")

                }
                else
                    throw Error("Template save error:" + res.statusText)
            })
            .then(result => {
                this.props.alert.success(result.message);
                this.props.toggle();
                this.props.refresh();
            })
            .catch(error => {
                this.setState({
                    saveError: true,
                    errorMessage: error
                })
            })
    }

    getX3Folders = async () => {
    try {
        const r = await fetch(`${window.location.origin}/api/sageX3/get_x3_folders`, {
        headers: { "Accept": "application/json" }
        });
 
        const payload = await r.json();
 
        if (!r.ok) {
        console.error("get_X3_folders failed", payload);
        this.setState({ isLoading: false });
        return;
        }
 
        this.setState({
        folders: payload?.folders ?? [],
        isLoading: false
        });
    } catch (err) {
        console.error("get_X3_folders error", err);
        this.setState({ isLoading: false });
    }
    };


    getX3FolderLanguages = async () => {
        const currentFolder = this.state.selectedFolder;
    
        if (this.isDefaultDropdownValue(currentFolder)) return;
    
        try {
            const response = await fetch(`/api/sageX3/get_folder_languages?folder=${currentFolder}`);
            const result = await response.json();
    
            // Only update if folder hasn't changed during fetch
            if (this.state.selectedFolder === currentFolder) {
                this.setState({
                    languages: result.data.ADSALAN,
                    isLoading: false
                });
            } else {
                console.warn("Skipped stale language list update due to folder change.");
            }
        } catch (error) {
            console.error("Failed to fetch folder languages:", error);
            this.setState({ isLoading: false });
        }
    };
    

    getX3ReportTypes = async () => {
        const { selectedFolder, selectedLanguage } = this.state;
    
        if (
            this.isDefaultDropdownValue(selectedFolder) ||
            this.isDefaultDropdownValue(selectedLanguage)
        ) return;
    
        const currentFolder = selectedFolder;
        const currentLanguage = selectedLanguage;
    
        try {
            const response = await fetch(`/api/configuration/documentTypes?folder=${currentFolder}&DocumentArea=x3`);
            const result = await response.json();
    
            // Validate current folder/language before setting state
            if (
                this.state.selectedFolder === currentFolder &&
                this.state.selectedLanguage === currentLanguage
            ) {
                this.setState({
                    resources: result,
                    isLoading: false
                });
            } else {
                console.warn("Skipped stale code list update due to dropdown change.");
            }
        } catch (error) {
            console.error("Failed to fetch codes:", error);
            this.setState({ isLoading: false });
        }
    };
    

    isDefaultDropdownValue = (value) => {
        return typeof value === 'string' && value.toLowerCase().includes('select');
    }   

    handleInputChange = (html) => {
        this.setState({
            html: html
        })
    }

    handleRawInputChange = (html) => {
        this.setState({
            rawhtml: html
        })
    }

    activateHtmlButton = () => {
        this.setState({
            showtext: !this.state.showtext
        })
    }

    handleFilterChange = (templates, selectTemplateIndex) => {
        this.setState({
            subject: templates[selectTemplateIndex].subject,
            templates: templates,
            selectTemplateIndex: selectTemplateIndex
        });
    }

    handleSubjectChange = (value, filtered) => {
        if (!filtered)
            this.setState({ subject: value })
        else {
            let templates = [...this.state.templates];
            templates[this.state.selectTemplateIndex].subject = value;

            this.setState({
                subject: value,
                templates: templates
            });
        }
    }

    handleAdminEmailChange = (value, filtered) => {
        if (!filtered)
            this.setState({ admin_email: value })
        else {
            let templates = [...this.state.templates];
            templates[this.state.selectTemplateIndex].admin_email = value;

            this.setState({
                admin_email: value,
                templates: templates
            });
        }
    }
    

    handleDropdownChange = async (event) => {
        const { name, value } = event.target;
    
        await this.setState({ [name]: value });
    
        const isFolder = name === 'selectedFolder';
        const isLanguage = name === 'selectedLanguage';
        const isCode = name === 'selectedCode';
    
        const isFolderDefault = this.isDefaultDropdownValue(this.state.selectedFolder);
        const isLanguageDefault = this.isDefaultDropdownValue(this.state.selectedLanguage);
        const isCodeDefault = this.isDefaultDropdownValue(this.state.selectedCode);
    
        if (isFolder) {
            this.setState({
                selectedLanguage: 'Select ...',
                selectedCode: 'Select ...',
                languages: [],
                resources: [],
                reportFields: null,
                valid: false
            });
    
            if (!isFolderDefault) {
                this.formIsLoading();
                await this.getX3FolderLanguages();
            }
        }
    
        if (isLanguage) {
            this.setState({
                selectedCode: 'Select ...',
                resources: [],
                valid: false,
                reportFields: null
            }, async () => {
                if (!isLanguageDefault && !isFolderDefault) {
                    this.formIsLoading();
                    await this.getX3ReportTypes();
                }
            });
        }
        
        if (isCode && !isCodeDefault) {
            try {
                this.downloadDocumentTypeConfigFields(value);
            } catch (error) {
                this.setState({
                    saveError: true,
                    errorMessage: "Failed to get document type config, please check document type is set up correctly"
                });
            }
        }

        const isValid = !isFolderDefault && !isLanguageDefault && !isCodeDefault;
        if (this.state.valid !== isValid) {
            this.setState({ valid: isValid });
        }

        this.showReminderAlertIfNeeded();
    };

    showReminderAlertIfNeeded = () => {
        const hasInteracted = true;
    
        const isFolderDefault = this.isDefaultDropdownValue(this.state.selectedFolder);
        const isLanguageDefault = this.isDefaultDropdownValue(this.state.selectedLanguage);
        const isCodeDefault = this.isDefaultDropdownValue(this.state.selectedCode);
    
        const shouldShowAlert = hasInteracted && (
            isFolderDefault || isLanguageDefault || isCodeDefault
        );
    
        this.setState({
            hasInteracted,
            showUserAlert: shouldShowAlert,
            userAlertType: shouldShowAlert ? 'info' : '',
            userAlertMessage: shouldShowAlert
                ? 'Please select a Folder, Language, and Report Code to proceed.'
                : ''
        });
    };
    

    downloadDocumentTypeConfigFields = (value) => {
        try {
            this.setState({
                saveError: false,
                errorMessage: ''
            })

            fetch(window.location.protocol + '//' + window.location.host + "/api/configuration/get_report_fields?report_code=" + value)
                .then(res => res.json())
                .then(result => {
                    let customDescriptions = [];

                    if (result) {
                        if (result.error) {
                            this.setState({
                                saveError: true,
                                errorMessage: "Failed to get document type config, please check document type is set up correctly"
                            })
                        }
                        else {
                            result.forEach(reportField => {
                                var a = `
                                
                                .ql-picker.ql-insertCustomTags [data-value="@model.DocumentData.` + reportField.Name + `"]::before {
                                    content: "` + reportField.Description.en + `"} 
                                    
                                    
                                    `;

                                customDescriptions.push(a);
                            })

                            this.setState({
                                reportFields: result,
                                customDescriptions: customDescriptions,
                                isLoading: false
                            })
                        }
                    }

                })
        }
        catch (error) {
            this.setState({
                saveError: true,
                errorMessage: "Failed to get document type config, please check document type is set up correctly"
            })
        }
    }

    templateExistsModalToggle = () => {
        this.setState({
            templateExistsModal: !this.state.templateExistsModal
        });
    }

    render() {
        let loading = <div />
        const { localisation } = this.props.userReducer;

        let filteredTemplates = [...this.state.templates];
        let alert = <></>;

        if (this.state.saveError && this.state.errorMessage) {
            alert = (
                <Alert color="danger" style={{ marginTop: '10px' }}>
                    {'Template save error: ' + this.state.errorMessage}
                </Alert>
            );
        } else if (this.state.showUserAlert && this.state.userAlertMessage) {
            alert = (
                <Alert color={this.state.userAlertType || 'info'} style={{ marginTop: '10px' }}>
                    {this.state.userAlertMessage}
                </Alert>
            );
        }

        if (filteredTemplates.length == 0)
            filteredTemplates.push({
                Name: 'Default',
                subject: '',
                admin_email: '',
                html: '',
                placeholder: localisation['email_text_placeholder'] ? localisation['email_text_placeholder'].element_lang : '',
                filter: ''
            });

        if (this.state.isLoading)
            loading = <Progress animated color="info" value={100} />

        if (this.state.saveError && this.state.errorMessage)
            alert = <Alert style={{ marginTop: '10px' }} color="danger">{'Template save error: ' + this.state.errorMessage}</Alert>


        let templateexistsmodal = <TemplateExistsModal visible={this.state.templateExistsModal} toggle={this.templateExistsModalToggle} saveTemplate={this.newVersionOfTemplate} />
        
        if (!this.state.reportFields) {
            return (
                <Modal isOpen={this.props.visible} toggle={this.props.toggle} className='modal-dialog'>
                    <ModalHeader toggle={this.props.toggle}>{this.props.copy ? (localisation['popover_copy'] ? localisation['popover_copy'].element_lang : '' + ':' + this.props.file.template) : (localisation['create_new_report'] ? localisation['create_new_report'].element_lang : '')}</ModalHeader>
                    <ModalBody>
                        <Row form>
                            <Col md={4}>
                                <ValidateSelect options={this.state.folders} name={"selectedFolder"} handleDropdownChange={this.handleDropdownChange} customType={'DOSSIER'} mandatory={true} labelText={localisation['table_header_folder'] ? localisation['table_header_folder'].element_lang : ''} />
                            </Col>
                            <Col md={4}>
                                <ValidateSelect options={this.state.languages} name={"selectedLanguage"} handleDropdownChange={this.handleDropdownChange} customType={'LAN'} mandatory={true} labelText={localisation['table_header_language'] ? localisation['table_header_language'].element_lang : ''} />
                            </Col>
                            <Col md={4}>
                                <ValidateSelect options={this.state.resources} name={"selectedCode"} handleDropdownChange={this.handleDropdownChange} customType={'DocumentType'} mandatory={true} labelText={localisation['table_header_code'] ? localisation['table_header_code'].element_lang : ''} />
                            </Col>
                        </Row>
                        {loading}
                        {alert}
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" disabled={!this.state.valid} onClick={this.checkTemplateExists}>{localisation['save_button'] ? localisation['save_button'].element_lang : 'Save'}</Button>
                        <Button color="secondary" onClick={this.props.toggle}>{localisation['close_button'] ? localisation['close_button'].element_lang : 'Close'}</Button>
                    </ModalFooter>
                    {templateexistsmodal}
                </Modal>
            );
        }
        else {
            return (
                <Modal isOpen={this.props.visible} toggle={this.props.toggle} className='modal-dialog' backdrop={'static'}>
                    <ModalHeader toggle={this.props.toggle}>{this.props.copy ? (localisation['popover_copy'] ? localisation['popover_copy'].element_lang : '' + ':' + this.props.file.template) : (localisation['create_new_report'] ? localisation['create_new_report'].element_lang : '')}</ModalHeader>
                    <ModalBody>
                        <Row form>
                            <Col md={4}>
                                <ValidateSelect options={this.state.folders} name={"selectedFolder"} handleDropdownChange={this.handleDropdownChange} customType={'DOSSIER'} mandatory={true} labelText={localisation['table_header_folder'] ? localisation['table_header_folder'].element_lang : ''} />
                            </Col>
                            <Col md={4}>
                                <ValidateSelect options={this.state.languages} name={"selectedLanguage"} handleDropdownChange={this.handleDropdownChange} customType={'LAN'} mandatory={true} labelText={localisation['table_header_language'] ? localisation['table_header_language'].element_lang : ''} />
                            </Col>
                            <Col md={4}>
                                <ValidateSelect options={this.state.resources} name={"selectedCode"} handleDropdownChange={this.handleDropdownChange} customType={'RPTEVT'} mandatory={true} labelText={localisation['table_header_code'] ? localisation['table_header_code'].element_lang : ''} />
                            </Col>
                        </Row>
                        {loading}
                        {this.state.valid && this.state.reportFields ? (
                        <>
                            <EmailSubject
                                options={this.state.reportFields}
                                subject={this.state.subject}
                                setSubject={this.handleSubjectChange}
                                filterTemplates={true}
                            />
                            <Row>
                                <Col>
                                    <FormGroup>
                                        <Label for="admin_email" className="s-field-title s-anchored">Admin Email</Label>
                                        <Input
                                            type="text"
                                            value={this.state.admin_email}
                                            name="admin_email"
                                            onChange={(e) => this.handleAdminEmailChange(e.target.value, true)}
                                        />
                                    </FormGroup>
                                    <FormGroup check>
                                        <Row>
                                            <Col md={5}>
                                                <Label for="useDefault" className="s-field-title s-anchored">
                                                    <Input type="checkbox" name={'useDefault'} checked={this.state.distributionReports} onClick={() => this.setState({ distributionReports: !this.state.distributionReports })} />{' '}
                                                    Send Distribution Report
                                                </Label>
                                            </Col>
                                            <Col md={5}>
                                                <Label for="useDefault" className="s-field-title s-anchored">
                                                    <Input type="checkbox" name={'useDefault'} checked={this.state.sendReportsOnCompletion} onClick={() => this.setState({ sendReportsOnCompletion: !this.state.sendReportsOnCompletion })} />{' '}
                                                    Only send report on process error
                                                </Label>
                                            </Col>
                                        </Row>
                                    </FormGroup>
                                    <FormGroup check style={{ marginTop: '25px' }}>
                                        <Label for="useDefault" className="s-field-title s-anchored">
                                            <Input type="checkbox" name={'useDefault'} checked={this.state.useDefault} onClick={this.useDefaultCheckChange} />{' '}
                                            Use Default
                                        </Label>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Editor
                                placeholder={localisation['email_text_placeholder'] ? localisation['email_text_placeholder'].element_lang : ''}
                                filteredTemplates={filteredTemplates}
                                text={this.state.showtext}
                                activateHtmlButton={this.activateHtmlButton}
                                reportFields={this.state.reportFields}
                                customDescriptions={this.state.customDescriptions}
                                updateTemplates={this.handleFilterChange}
                            />
                        </>
                    ) : null}
                        {alert}
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" disabled={!this.state.valid} onClick={this.checkTemplateExists}>{localisation['save_button'] ? localisation['save_button'].element_lang : 'Save'}</Button>
                        <Button color="danger" onClick={this.props.toggle}>{localisation['close_button'] ? localisation['close_button'].element_lang : 'Close'}</Button>
                    </ModalFooter>
                    {templateexistsmodal}
                </Modal>
            );
        }


    }
}

export default connect(state => state)(withAlert()(NewReportModal));



